// extracted by mini-css-extract-plugin
export default {"layoutContainer":"layout_layoutContainer__tALeJ","main":"layout_main__SY9dW","profileLayout":"layout_profileLayout__YgyMV"};